import { Injectable } from '@angular/core';
import { Urls } from '../utilities/urls.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
import { Status, Product, Direction, Destination, Country ,Movement} from '../models/TransactionBalanceFilterDTO';
// import { RequestOptions } from '@angular/http';

@Injectable()
export class TransactionBalanceFilterService {
  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }
  getStatusList() {
    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTION_BALANCE_FILTER.getStatus;
    return this.http.get<Status>(url, this.headers.getCommonHttpHeaders());
  }
  getProductList(partnerCode:string) {

    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTION_BALANCE_FILTER.getProduct + partnerCode;
    return this.http.post<Product>(url, {}, this.headers.getCommonHttpHeaders());
  }
  getDirectionList() {
    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTION_BALANCE_FILTER.getDirection;
    return this.http.get<Direction>(url, this.headers.getCommonHttpHeaders());
  }
  getDestinationTypeList() {
    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTION_BALANCE_FILTER.getDestinationType;
    return this.http.get<Destination>(url, this.headers.getCommonHttpHeaders());
  }
  getCountriesList() {
    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTION_BALANCE_FILTER.getCountries;
    return this.http.get<Country>(url, this.headers.getCommonHttpHeaders());
  }
  getMovementTypeList() {
    var url: string = Urls.API_ENDPOINT + Urls.TRANSACTION_BALANCE_FILTER.getMovementType;
    return this.http.get<Movement>(url, this.headers.getCommonHttpHeaders());
  }
}
